import { useMutation, useQueryClient } from "@tanstack/react-query";
import useApiAuth from "./useApiAuth";

const useTokenLogin = () => {
    const { tokenLogin } = useApiAuth();

    return useMutation({
        mutationFn: (token: string) => tokenLogin(token)
    })
}

export default useTokenLogin;